import React, { useEffect, useState } from 'react';
import researchApi from '/src/apis/researchApi';
import AmplitudeHelperClass from '/src/utilities/amplitudeHelper';
import { WEB_URL } from '/src/utilities/endpoints';
import { getItemWebUrl } from '/src/utilities/helpers';
import { ar, en } from "/src/utilities/constants/dictionary";



const amplitudeHelper = new AmplitudeHelperClass();

const TableOfContents = (props) => {
    // table_of_contents = Table of contents for this report
    // table_of_contents_promoted = (optional) Table of contents for promoted report i.e. paid version of free report
    const { table_of_contents, table_of_contents_promoted, promoted_research_id, lang, name } = props.report;
    const isPromotingAnotherReport = (table_of_contents_promoted);
    const [promotedReportLink, setPromotedReportLink] = useState(`${WEB_URL}/research`);
    const dictionary = (lang === "ar" ? ar() : en())

    useEffect(async () => {
        if (isPromotingAnotherReport && promoted_research_id) {
            const fields = ['code', 'id']; // only call required fields
            const data = await researchApi.getResearchDetails(promoted_research_id, fields);
            if (data !== 404 && data.researchData) {
                const rdata = data.researchData;
                const reportLink = getItemWebUrl('research', rdata.id, rdata.code);
                setPromotedReportLink(`${WEB_URL}/${reportLink}`);
            }
        }
    }, [])

    const amplitudeTrack = () => {
        amplitudeHelper.trackEvent('Clicked to Premium Report from TOC', {
            report_name: name,
        });
    }

    if (table_of_contents) {
        return (
            <div className="content-body-widget-main table-of-contents" lang={lang}>
                <div className="db-box widget-box">

                    {/* table of contents - current report */}
                    <div className="db-header">
                        <div>
                            <div>{dictionary.whatsInThisReport}</div>
                        </div>
                    </div>
                    {isPromotingAnotherReport &&
                        <p className="contents-heading" lang={lang}>
                            {dictionary.whatsInThisReport_free}
                        </p>
                    }
                    <p className="contents-text">{table_of_contents}</p>

                    {/* table of contents - promoted report */}
                    {isPromotingAnotherReport &&
                        <>
                            <hr />
                            <a href={promotedReportLink} className="no-underline" target="_blank" rel="noopener noreferrer" onClick={() => amplitudeTrack()}>
                                <p className="contents-heading contents-heading-premium" lang={lang}>
                                    {dictionary.whatsInThisReport_paid}
                                </p>
                            </a>
                            <p className="contents-text">{table_of_contents_promoted}</p>
                        </>
                    }

                </div>
            </div>
        )
    } else {
        return null;
    }
}

export default TableOfContents;
